<form [formGroup]="form">
  <ng-template [ngTemplateOutlet]="SkipIfNullField"></ng-template>
  <mat-form-field class="w100">
    <mat-label>{{ 'SensorEvent.type'|translate }}</mat-label>
    <mat-select formControlName="type">
      @for (type of SensorEventStatementType|transformValueByPredicateFunction:predicatePossibleValueType; track type) {
        <mat-option
          [value]="type.valueForm">
          {{ type.traduction|translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <ng-template [ngTemplateOutlet]="DeltaRangeField"></ng-template>

  @switch (type$|async) {
    @case (SensorEventStatementType.CALENDAR) {
      <ng-container
        [ngTemplateOutlet]="OperatorField"
        [ngTemplateOutletContext]="{ possibleValues: calendarsModalityOperators }">
      </ng-container>
      <button color="primary"
        mat-flat-button [matMenuTriggerFor]="SELECTCALENDAR">
        @if (selectCalendar$|async; as calendar) {
          {{ calendar.name }}
        } @else {
          {{ 'CalendarParse.select'|translate }}
        }
      </button>
    }
    @case (SensorEventStatementType.FIXED) {
      <ng-template [ngTemplateOutlet]="SENSORINFONAME">
      </ng-template>
      <mat-form-field class="w100">
        <mat-label>{{ 'SensorEvent.config'|translate }}</mat-label>
        <input matInput formControlName="configTypeFixed" type="number">
      </mat-form-field>
    }
    @case (SensorEventStatementType.SCENARIO) {
      <ng-template [ngTemplateOutlet]="SENSORINFONAME">
      </ng-template>
      <mat-card formGroupName="configTypeSensor">
        <mat-card-content>
          <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>
          @if (elements|transformValueByPredicateFunction:predicatePossibleValuesElementsRaggruped:('suggested'|translate):('other'|translate); as pValues) {
            <app-auto-complete-form
              class="width-form-field"
              [title]="'SensorEvent.sensorId'|translate"
              [itemsGroup]="pValues"
              appearance="fill"
              [hiddenClearButton]="true"
              formControlName="sensorId"
              >
            </app-auto-complete-form>
          }
        </mat-card-content>
      </mat-card>
    }
    @case (SensorEventStatementType.SENSOR) {
      <ng-template [ngTemplateOutlet]="SENSORINFONAME">
      </ng-template>
      <mat-card formGroupName="configTypeSensor">
        <mat-card-content>
          <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>
          @if (elements|transformValueByPredicateFunction:predicatePossibleValuesElementsRaggruped:('suggested'|translate):('other'|translate); as pValues) {
            <app-auto-complete-form
              class="width-form-field"
              [title]="'SensorEvent.sensorId'|translate"
              [itemsGroup]="pValues"
              appearance="fill"
              [hiddenClearButton]="true"
              formControlName="sensorId"
              >
            </app-auto-complete-form>
          }
          @if ((configElement$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoNameGrouped:sensorDataType:('suggested'|translate):('other'|translate); as pValues) {
            <app-auto-complete-form
              class="width-form-field"
              [title]="'SensorEvent.infoName'|translate"
              [itemsGroup]="pValues"
              appearance="fill"
              [hiddenClearButton]="true"
              formControlName="infoName"
              >
            </app-auto-complete-form>
          }
        </mat-card-content>
      </mat-card>
    }
    @case (SensorEventStatementType.FUNCTIONALITY_STATUS) {
      <ng-container
        [ngTemplateOutlet]="OperatorField"
        [ngTemplateOutletContext]="{ possibleValues: functionalityModalityOperators }">
      </ng-container>
      <mat-card-content>
        <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>
        <mat-form-field class="w100">
          <mat-label>{{ 'SensorEvent.type'|translate }}</mat-label>
          <mat-select formControlName="configTypeFixed">
            @for (type of SensorEventStatementFunctionality_StatusType|transformValueByPredicateFunction:predicateSensorEventStatementFunctionality_StatusType; track type) {
              <mat-option
                [value]="type.valueForm">
                {{ type.traduction|translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    }
    @case (SensorEventStatementType.ACTIVITY_STATUS) {
      <ng-container
        [ngTemplateOutlet]="OperatorField"
        [ngTemplateOutletContext]="{ possibleValues: functionalityModalityOperators }">
      </ng-container>
      <mat-card-content>
        <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>
        <mat-form-field class="w100">
          <mat-label>{{ 'SensorEvent.type'|translate }}</mat-label>
          <mat-select formControlName="configTypeFixed">
            @for (type of SensorEventStatementModalityType|transformValueByPredicateFunction:predicateSensorEventStatementActivity_StatusType; track type) {
              <mat-option
                [value]="type.valueForm">
                {{ type.traduction|translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    }
    @case (SensorEventStatementType.PROGRAM) {
      <ng-template
        [ngTemplateOutlet]="OperatorField"
        [ngTemplateOutletContext]="{ possibleValues: opPossibleValues }">
      </ng-template>
      <mat-card formGroupName="configTypeProgram">
        <mat-card-content>
          <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>

          <mat-form-field class="w100">
            <mat-label>{{ 'SensorEvent.days'|translate }}</mat-label>
            <mat-select formControlName="days" multiple>
              @for (day of daysOfWeek; track day) {
                <mat-option [value]="day.id">
                  {{ ('weekDay.' + day.id)|translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="time-selection">
            <mat-form-field class="time-field">
              <mat-label>{{ 'SensorEvent.start_hours'|translate }}</mat-label>
              <input matInput formControlName="start_hours" type="number" min="0" max="23">
            </mat-form-field>

            <mat-form-field class="time-field">
              <mat-label>{{ 'SensorEvent.startMinutes'|translate }}</mat-label>
              <input matInput formControlName="start_minutes" type="number" min="0" max="59">
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @case (SensorEventStatementType.AGGREGATE) {
      <button mat-button type="button" (click)="toggleAllSensors(true)">
        {{ 'enableSelection'|translate }}
      </button>
      @if (elements) {
        <app-multi-select-form-field formControlName="sensorIds" [multiple]="true"
          [labelSearch]="'search_generic'|translate"
          [possibleValues]="elements | transformValueByPredicateFunction:predicatePossibleValuesForMultiSelect">
        </app-multi-select-form-field>
      }
      <ng-template
        [ngTemplateOutlet]="OperatorField"
        [ngTemplateOutletContext]="{ possibleValues: opPossibleValues }">
      </ng-template>
      <mat-card formGroupName="configTypeAggregate">
        <mat-card-content>
          <mat-card-subtitle>{{ 'SensorEvent.config'|translate }}</mat-card-subtitle>

          <mat-form-field class="w100">
            <mat-label>{{ 'SensorEvent.type'|translate }}</mat-label>
            <mat-select formControlName="op">
              @for (op of StatementConfigOp|transformValueByPredicateFunction:predicateSensorEventStatementActivity_Operator; track op) {
                <mat-option
                  [value]="op.valueForm">
                  {{ op.traduction|translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w100">
            <mat-label>{{ 'value'|translate }}</mat-label>
            <input matInput formControlName="value" type="number">
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    }
  }
</form>

<ng-template #SENSORINFONAME>
  <form [formGroup]="form">
    @if (elements|transformValueByPredicateFunction:predicatePossibleValuesElementsRaggruped:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field"
        [title]="'SensorEvent.sensorId'|translate"
        [itemsGroup]="pValues"
        appearance="fill"
        [hiddenClearButton]="true"
        formControlName="sensorId"
        >
      </app-auto-complete-form>
    }
    @if ((element$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoNameGrouped:sensorDataType:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field"
        [title]="'SensorEvent.infoName'|translate"
        [itemsGroup]="pValues"
        appearance="fill"
        [hiddenClearButton]="true"
        formControlName="infoName"
        >
      </app-auto-complete-form>
    }
    <mat-form-field class="w100">
      <mat-label>op</mat-label>
      <mat-select formControlName="op">
        @for (op of opPossibleValues|transformValueByPredicateFunction:predicateOperator:(infoName$|async):SpecialInfoName; track op) {
          <mat-option
            [value]="op">
            <div class="w100 flex-between-center">
              <mat-icon [svgIcon]="op" style="margin: 0 15px 0 0"></mat-icon>
              {{ ('operator.' + op)|translate }}
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!--        <mat-form-field class="w100">-->
    <!--            <mat-label>{{ 'SensorEvent.deltaRange'|translate }}</mat-label>-->
    <!--            <input matInput formControlName="deltaRange" type="number">-->
  <!--        </mat-form-field>-->
</form>
</ng-template>

<ng-template #OperatorField let-possibleValues="possibleValues">
  <form [formGroup]="form">
    <mat-form-field class="w100">
      <mat-label>op</mat-label>
      <mat-select formControlName="op">
        @for (op of possibleValues|transformValueByPredicateFunction:predicateOperator:(infoName$|async):SpecialInfoName; track op) {
          <mat-option
            [value]="op">
            <div class="w100 flex-between-center">
              <!--                        <mat-icon [svgIcon]="op" style="margin: 0 15px 0 0"></mat-icon>-->
              {{ ('operator.' + op)|translate }}
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #SkipIfNullField>
  <form [formGroup]="form">
    @if ((type$ | async) !== SensorEventStatementType.PROGRAM &&
      (type$ | async) !== SensorEventStatementType.AGGREGATE) {
      <mat-checkbox formControlName="skipIfNull">
        {{ 'SensorEvent.skipIfNull'| translate }}
      </mat-checkbox>
    }
  </form>
</ng-template>

<ng-template #DeltaRangeField>
  <form [formGroup]="form">
    @if (![SensorEventStatementType.PROGRAM,SensorEventStatementType.CALENDAR].includes((type$ | async)!)) {
      <mat-form-field class="w100"
        >
        <mat-label>{{ 'SensorEvent.deltaRange'|translate }}</mat-label>
        <input matInput formControlName="deltaRange" type="number">
      </mat-form-field>
    }
  </form>
</ng-template>


<mat-menu #SELECTCALENDAR panelClass="transparent-menu">
  <form class="flex-center-center flex-direction-row"
    style="width: 100vw ">
    <h2 class="w100" style="text-align: center">{{ 'CalendarParse.select'|translate }}</h2>
    <mat-divider></mat-divider>
    <div class="flex-start-stretch flex-direction-row" style="max-width: 100%">
      @for (calendar of calendars; track calendar) {
        <div class="grid-item background-color-primary-transparent-hoover pointer" style="padding: 4px"
          [ngClass]="calendar|transformValueByPredicateFunction:getSelectColor:(selectCalendarId$|async)">
          <app-box-calendar [calendar]="calendar" (click)="setCalendar(calendar)">
          </app-box-calendar>
        </div>
      }
    </div>
  </form>
</mat-menu>